module.exports = __webpack_public_path__ + "images/volkswagen_smallbef21f496f97045a6ea66dff6233b6cb.png";